import StyledAuthContainer from '@/components/auth/StyledAuthContainer';
import StyledButton from '@/components/styled/StyledButton';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PATHS } from '@/constants/Paths';
import React from 'react';
import { useNavigate } from 'react-router';
import DistributorRegisterForm from '@/components/auth/DistributorRegisterForm';
import ReceiverRegisterForm from '@/components/auth/ReceiverRegisterForm';
import { useTranslation } from '@/i18n';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <StyledAuthContainer
        title={t('auth.accountOpening')}
        footerMessage={t('auth.alreadyHaveAccount')}
        footerLink={
          <StyledButton
            title={t('auth.signIn')}
            variant="link"
            size="sm"
            className="h-6 px-1 py-0 gap-1 text-brand-600"
            onClick={() => navigate(PATHS.auth.login)}
          />
        }
      >
        <Tabs defaultValue="distributor" className="w-full">
          <TabsList className="w-full">
            <TabsTrigger
              value="distributor"
              className="w-full hover:cursor-pointer"
            >
              {t('auth.distributorAccount')}
            </TabsTrigger>
            <TabsTrigger
              value="receiver"
              className="w-full hover:cursor-pointer"
            >
              {t('auth.receiverAccount')}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="receiver">
            <ReceiverRegisterForm />
          </TabsContent>
          <TabsContent value="distributor">
            <DistributorRegisterForm />
          </TabsContent>
        </Tabs>
      </StyledAuthContainer>
    </>
  );
};

export default RegisterPage;
